import React, { useState } from 'react';
import ImagePicker from '../../components/inputFields/ImagePicker';
import { Form, Formik } from 'formik';
import * as Yup from "yup";
import InputField from '../../components/inputFields/InputField';
import Button from '../../components/buttons/Button';

function AddressView() {
    const [isEditing, setEditing] = useState(false);

    const handleEditing = (value) => {
        setEditing(value);
    };

    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
    };

    return (
        <Formik
            initialValues={{
                shop_name: "",
                phone_number_1: "",
                owner_contact: "",
                whatsapp_number: "",
                shop_email: "",
            }}
            validationSchema={Yup.object({
                shop_name: Yup.string().required("Please enter your Name"),
                phone_number_1: Yup.string().required("Please enter your Email"),
                owner_contact: Yup.string().required("Please enter your Phone Number"),
                whatsapp_number: Yup.string().required("Please Provide Whatsapp"),
                shop_email: Yup.string().required("Please Provide Email"),
            })}
            onSubmit={handleFormSubmit}
        >
            {({ isSubmitting }) => (
                <Form>
                    <div className="grid gap-6 md:grid-cols-3 lg:grid-cols-4">
                        <InputField
                            label="Shop No/Office No/ Building"
                            name="shop_no"
                            type="text"
                            placeholder="Enter Shop No/Office No/ Building"
                            disable={!isEditing}
                        />
                        <InputField
                            label="Street Name/ Area Name"
                            name="street_name"
                            type="text"
                            placeholder="Enter Street Name/ Area Name"
                            disable={!isEditing}
                        />
                        <InputField
                            label="Landmark"
                            name="landmark"
                            type="text"
                            placeholder="Enter Landmark"
                            disable={!isEditing}
                        />
                    </div>
                    <div className="grid gap-6 md:grid-cols-3 lg:grid-cols-4">
                        <InputField
                            label="City"
                            name="city"
                            type="text"
                            placeholder="City"
                            disable={!isEditing}
                        />
                        <InputField
                            label="District"
                            name="district"
                            type="text"
                            placeholder="District"
                            disable={!isEditing}
                        />
                        <InputField
                            label="State"
                            name="state"
                            type="text"
                            placeholder="State"
                            disable={!isEditing}
                        />
                        <InputField
                            label="Pincode"
                            name="pincode"
                            type="text"
                            placeholder="Pincode"
                            disable={!isEditing}
                        />
                        <InputField
                            label="Country"
                            name="country"
                            type="text"
                            placeholder="Country"
                            disable={!isEditing}
                        />
                    </div>
                    {
                        isEditing ?

                            <div className="flex flex-row max-h-12 gap-4 my-2 max-w-40">
                                <Button
                                    type="submit"
                                    className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Loading..." : "Save"}
                                </Button>
                                <Button
                                    className="text-black bg-secondary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                    disabled={isSubmitting}
                                    onClick={() => handleEditing(false)}
                                >
                                    {"Cancel"}
                                </Button>
                            </div> :
                            <div className='my-2'>
                                <Button
                                    className="text-white max-w-20 bg-slate-800 hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                    onClick={() => handleEditing(true)}
                                >
                                    {"Edit"}
                                </Button>
                            </div>
                    }
                </Form>
            )}
        </Formik>
    );
}

export default AddressView;
